import { seoContent } from '@/mocks/home';

export function SEOContentSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="space-y-8">
          {seoContent.sections.map((section) => (
            <div key={section.heading}>
              <h4 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                <a href="#" className="cursor-pointer hover:text-primary-600 transition-colors">
                  {section.heading}
                </a>
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}